module.exports = __webpack_public_path__ + "media/images/pages/gender-balance/hero-teacher-ebb05d905c66ae2b241019ffba3ca2ce.jpg";